import { z } from 'zod';
import { EmailReminderTriggerType } from '@/api/entities/email-reminder';

export const emailReminderSchema = z.object({
  id: z.string().optional(),
  triggerDay: z.number().nullish(),
  emailTemplateId: z.string().nullish(),
  triggerType: z.nativeEnum(EmailReminderTriggerType).nullish(),
  sendNow: z.boolean().default(false),
  globalEmailSettingId: z.string().nullish(),
  groupId: z.string().nullish(),
});

export type TEmailReminderSchema = z.infer<typeof emailReminderSchema>;
